// import iconcus from "../../../assets/images/kirkos_logo.svg";
import { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "./signupboot.css";
import {
  icon_normal,
  car_sign_up,
  kirkos_logo_white_yellow
} from "../../../assets/images";
import {
  CustomInput,
  ErrorModal,
  CustomerOnboardLeftSide,
  Progressbar,
  SuccessModal,
  Turnstile,
} from "../../../components";
import { TurnstileRef } from "../../../components/Turnstile";
import { useForm } from "react-hook-form";
import rules from "../../../rules";
import { useQueryClient, useQuery, useMutation } from "@tanstack/react-query";
import { trackEvent } from "../../../services/events";
import axiosInstance from "../../../services/axios.instance";
import { API_URL } from "../../../services/apiConfig";
import { UserData, VerifyOtp } from "../../../types";
import { Navigate, useNavigate, Link } from "react-router-dom";
import "../authFlow.css";
import DraggableWhatsAppIcon from "../../../components/CustomerDashBoard/DraggableWhatsAppIcon";

const CustomerSignUpFormBoot = () => {
  const [phoneNum, setPhoneNum] = useState<any>("");
  const [transactionId, setTransactionId] = useState<number | undefined>(0);
  const [showOtpscreen, setShowOtpscreen] = useState<boolean>(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState<string | null>(null);
  const turnstileRef = useRef<TurnstileRef>(null);
  const signupFormDataRef = useRef<any>(null);
  const cachedTokenRef = useRef<{ token: string; timestamp: number } | null>(null);

  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { isValid },
    setValue,
    trigger,
  } = useForm({ mode: "onChange" });

  useEffect(() => {
    const trackPageLoad = async () => {
      await trackEvent({
        event_name: { web: "Kirkos_SignUp", app: "Kirkos_SignUp_App" },
        event_category: "SignUp",
        module: "Registration ",
        payload: {},
      });
    };
    trackPageLoad();
  }, []);

  useEffect(() => {
    setIsPhoneValid(phoneNum.length === 9);
  }, [phoneNum]);

  const handleTurnstileSuccess = (token: string) => {
    setTurnstileToken(token);
    cachedTokenRef.current = { token, timestamp: Date.now() };

    const data = signupFormDataRef.current;
    if (data) {
      const userData = {
        phoneNo: data.phoneNo,
        userType: "CONSUMER",
        event: "register",
        turnstile_response: token,
      };

      mutation.mutate(userData);
      signupFormDataRef.current = null;
    }
  };

  const handleClick = async (data: any) => {
    setPhoneNum(data.phoneNo);
    signupFormDataRef.current = data;
    setTurnstileToken(null);
    
    // Check if we have a cached token that's less than 5 minutes old
    const now = Date.now();
    if (cachedTokenRef.current && (now - cachedTokenRef.current.timestamp < 5 * 60 * 1000)) {
      handleTurnstileSuccess(cachedTokenRef.current.token);
      return;
    }
    
    // Otherwise, execute fresh verification
    turnstileRef.current?.reset();
    turnstileRef.current?.execute();
  };

  const onHandleError = (errors: any) => {
    const firstError = Object.values(errors)[0] as any;
    if (firstError) {
      toast.error(firstError.message || "Please check your mobile number");
    } else if (!isPhoneValid) {
      toast.error("Please enter a valid 9-digit mobile number");
    }
  };

  const mutation = useMutation({
    mutationFn: async (userData: UserData) => {
      const response = await axiosInstance.post(API_URL.SEND_OTP, userData);
      return response;
    },
    onSuccess: async (successResponse) => {
      if (successResponse?.status && successResponse?.data?.transactionId) {
        await trackEvent({
          event_name: { web: "Kirkos_Phone_SignUp", app: "Kirkos_Phone_SignUp_App" },
          event_category: "SignUp",
          module: "Registration",
          payload: {
            status: "success",
            message: successResponse?.data?.message ?? "",
          },
        });

        setTransactionId(successResponse.data.transactionId);
        sessionStorage.setItem(
          "transactionId",
          successResponse.data.transactionId.toString()
        );
        navigate("./otpscreen", {
          state: { phoneNum: phoneNum, transactionId: transactionId },
        });
        // setShowSuccessModal(true);
      } else if (successResponse?.status === 201 && successResponse?.data?.message) {
        setErrorMessage(successResponse.data.message);
        setShowErrorModal(true);
      } else {
        setErrorMessage("Invalid response from server");
        setShowErrorModal(true);
      }
    },
    onError: (error: any) => {
      console.error("Mutation error:", error);
      turnstileRef.current?.reset();
      setTurnstileToken(null);
      signupFormDataRef.current = null;
      cachedTokenRef.current = null;
      const errorMessage = error?.data?.message || error?.message || "An error occurred while sending OTP";
      setErrorMessage(errorMessage);
      setShowErrorModal(true);
    },
  });
  return (
    <>
      <div className="customer-auth-page">
        <div className="customer-auth-shell">
          <div className="customer-auth-brand-panel">
            <div className="customer-auth-brand-topbar">
              <Link to="/" className="customer-auth-logo-link" aria-label="Kirkos home">
                <img
                  src={kirkos_logo_white_yellow}
                  alt="Kirkos"
                  className="customer-auth-logo"
                />
              </Link>
              <div className="customer-auth-brand-links">
                <Link to="/" className="customer-auth-brand-link">
                  Home
                </Link>
                <Link to="/signin" className="customer-auth-brand-link">
                  Login
                </Link>
              </div>
            </div>

            <div className="customer-auth-brand-content">
              <div>
                <span className="customer-auth-eyebrow">Customer onboarding</span>
                <h1 className="customer-auth-brand-title">
                  Create your Kirkos account in a few quick steps.
                </h1>
                <p className="customer-auth-brand-copy">
                  Start with your mobile number, verify securely, and move into
                  a smoother rental experience designed around premium support
                  and faster booking access.
                </p>
              </div>

              <div className="customer-auth-brand-highlights">
                <div className="customer-auth-highlight-card">
                  <span className="customer-auth-highlight-value">Step 1</span>
                  <span className="customer-auth-highlight-label">
                    Secure mobile verification before account creation
                  </span>
                </div>
                <div className="customer-auth-highlight-card">
                  <span className="customer-auth-highlight-value">Fast</span>
                  <span className="customer-auth-highlight-label">
                    Onboarding built to get you browsing sooner
                  </span>
                </div>
                <div className="customer-auth-highlight-card">
                  <span className="customer-auth-highlight-value">Trust</span>
                  <span className="customer-auth-highlight-label">
                    A polished journey aligned with the Kirkos experience
                  </span>
                </div>
              </div>

              <div className="customer-auth-car-stage">
                <div className="customer-auth-car-glow" />
                <img
                  src={car_sign_up}
                  className="customer-auth-car-image"
                  alt="Kirkos signup journey"
                />
              </div>
            </div>
          </div>

          <div className="customer-auth-card">
            <div className="customer-auth-card-head">
              <div className="customer-auth-progress">
                <Progressbar currentStage={1} />
              </div>
              <div className="customer-auth-card-icon-wrap">
                <img
                  src={icon_normal}
                  className="customer-auth-card-icon"
                  alt="Customer sign up"
                />
              </div>
              <span className="customer-auth-card-kicker">Create account</span>
              <h2 className="customer-auth-heading">Start with your phone</h2>
              <p className="customer-auth-subcopy">
                We will send a one-time password to confirm your mobile number
                before we collect the rest of your account details.
              </p>
              <div className="customer-auth-links-row">
                <span className="customer-auth-links-label">Already registered?</span>
                <Link to="/signin" className="customer-auth-inline-link">
                  Login
                </Link>
                <Link to="/" className="customer-auth-inline-link">
                  Back to home
                </Link>
              </div>
            </div>

            <div className="customer-auth-scroll-area">
              <div className="customer-auth-field-block">
                <label className="customer-auth-label">
                  Mobile number <span className="customer-auth-required">*</span>
                </label>
                <div className="customer-auth-input-shell">
                  <span className="customer-auth-country-code">
                    <img
                      src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDYwMCAzMDAiPgogIDxyZWN0IHdpZHRoPSI2MDAiIGhlaWdodD0iMTAwIiBmaWxsPSIjMDA3MzJmIi8+CiAgPHJlY3Qgd2lkdGg9IjYwMCIgaGVpZ2h0PSIxMDAiIHk9IjEwMCIgZmlsbD0iI2ZmZiIvPgogIDxyZWN0IHdpZHRoPSI2MDAiIGhlaWdodD0iMTAwIiB5PSIyMDAiIGZpbGw9IiMwMDAiLz4KICA8cmVjdCB3aWR0aD0iMTUwIiBoZWlnaHQ9IjMwMCIgZmlsbD0iI2ZmMDAwMCIvPgo8L3N2Zz4="
                      alt="UAE"
                      className="customer-auth-flag"
                    />
                    +971
                  </span>
                  <CustomInput
                    inputName="phoneNo"
                    inputType="tel"
                    className="customer-auth-input"
                    placeholder="Enter your mobile number"
                    editable={true}
                    onInputChange={(value: string) => setPhoneNum(value)}
                    control={control}
                    maxLength={9}
                    rules={rules.AuthRules.phone_number}
                    autoFocus={true}
                  />
                </div>
              </div>

              <div className="customer-auth-turnstile-container" style={{ display: "none" }}>
                <Turnstile
                  ref={turnstileRef}
                  sitekey={process.env.REACT_APP_TURNSTILE_SITEKEY || ""}
                  appearance="interaction-only"
                  execution="execute"
                  onSuccess={handleTurnstileSuccess}
                  onError={() => {
                    setTurnstileToken(null);
                    signupFormDataRef.current = null;
                    toast.error("Security verification failed. Please try again.");
                  }}
                  onExpire={() => {
                    setTurnstileToken(null);
                    signupFormDataRef.current = null;
                    toast.warning("Security verification expired. Please verify again.");
                  }}
                />
              </div>

              <button
                className="customer-auth-button-primary"
                onClick={handleSubmit(handleClick, onHandleError)}
              >
                Continue to verify
              </button>

              <div className="customer-auth-bottom-support">
                <span className="customer-auth-support-tag">What happens next</span>
                <p className="customer-auth-support-msg">
                  You will receive an OTP by SMS to verify your phone number
                  and continue to the next step of registration.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SuccessModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        onNav={() => {
          navigate("./otpscreen", {
            state: { phoneNum: phoneNum, transactionId: transactionId },
          });
        }}
        message="Otp Send Successfully"
      />
      <ErrorModal
        isOpen={showErrorModal}
        //  onClose={onCloseErrorModal}
        onClose={() => setShowErrorModal(false)}
        message={errorMessage}
      />
      <DraggableWhatsAppIcon />
    </>
  );
};

export default CustomerSignUpFormBoot;
